import config from "./config";
import apiService from "./apiService";
export default {
    async getEngegementCount(clientId) {
      let clientApiUrl = `${config.engagementdashboardurl}?encryptClientId=${clientId}`;
      return apiService.get(clientApiUrl);
    },
  };